import React from 'react';
import PropTypes from 'prop-types';
import Chevron from './chevron';
import Switch from '@component/form/element/switch';
import classNames from 'classnames';
import { DescriptionContainer } from './descriptions';

export const alignments = { TOP_RIGHT: 1, BOTTOM_RIGHT: 2 };

export function Consent({
  onToggle,
  className,
  consentName,
  consentSwitchesProps,
  descriptionVisible,
  align = alignments.BOTTOM_RIGHT,
  children,
}) {
  const switches = consentSwitchesProps.map(({ name, ...props }) => (
    <Switch key={name} name={name} {...props} />
  ));

  return (
    <div className={className}>
      <div className="consent__section">
        <div className="consent__header">
          <div className="consent__icon-container" onClick={onToggle}>
            <Chevron
              className={classNames('consent__icon', {
                'consent__icon--rotated': descriptionVisible,
              })}
              width="10"
            />
          </div>
          <p onClick={onToggle} className="consent__title">
            {consentName}
          </p>
          {align === alignments.TOP_RIGHT && (
            <div className="consent__switches consent__switches--top">
              {switches}
            </div>
          )}
        </div>
        {align === alignments.BOTTOM_RIGHT && (
          <div className="consent__switches consent__switches--bottom">
            {switches}
          </div>
        )}
      </div>
      <DescriptionContainer isVisible={descriptionVisible}>
        {children}
      </DescriptionContainer>
    </div>
  );
}

Consent.propTypes = {
  align: PropTypes.number,
  onToggle: PropTypes.func.isRequired,
  consentName: PropTypes.string.isRequired,
  className: PropTypes.string,
  descriptionVisible: PropTypes.bool,
  consentSwitchesProps: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
};
